export function NotFound() {
  return (
    <div className="h-screen bg-inpay-green-primary-1000 text-center text-white">
      <h1>Page not found!</h1>
      <p>
        You seem to be in the wrong place. Please return to{' '}
        <a href="/" className="underline">
          documentation page
        </a>
      </p>
    </div>
  );
}
